import type { FocusListOption } from 'features/catalog/types'

/**
 * Whether a catalog sidebar item matches a search term against its title or,
 * for product-hierarchy items, any of its source URLs (plain case-insensitive
 * substring — e.g. searching an ASIN matches a source URL containing it).
 */
export const matchesFocusSearch = (
  item: Pick<FocusListOption, 'value' | 'source_urls'>,
  searchLower: string,
): boolean =>
  item.value.toLowerCase().includes(searchLower) ||
  (item.source_urls?.some((url) => url.toLowerCase().includes(searchLower)) ??
    false)
